var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Polaris-CalloutCard_Image_Icon ",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6466 22.0235C-4.60465 43.0159 6.55287 81.3641 30.9431 89.1881C55.3334 97.012 84.668 88.9461 93.3522 59.4806C99.1416 39.8369 89.6755 23.8311 64.9539 11.463C40.2499 4.5085 22.4808 8.02868 11.6466 22.0235Z",
    fill: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8175 14.0465C38.4658 7.14196 72.8246 23.357 73.9331 25.4284C75.0416 27.4999 68.2065 51.5969 65.6103 52.8356C63.0141 54.0743 25.3731 41.9861 24.0751 39.5422C22.7772 37.0984 25.1692 20.951 31.8175 14.0465Z",
    fill: "#DBDDF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7732 40.5813C17.2038 34.1214 35.8403 22.9228 40.8019 22.7947C45.7634 22.6666 46.0269 35.3666 49.0617 36.7589C52.0236 38.1179 57.0809 33.4295 60.5979 34.7516C64.1149 36.0737 71.4999 49.2669 66.2406 52.2269C60.9813 55.1869 30.3426 47.0412 23.7732 40.5813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3881 40.2841C23.1375 37.1397 37.3905 26.0581 41.0178 26.7702C44.6451 27.4822 45.0315 37.4539 48.8142 39.3414C52.597 41.229 58.3954 35.0983 60.9138 37.7123C63.4321 40.3263 69.4288 50.5533 66.2831 51.6394C63.1374 52.7254 29.6386 43.4286 26.3881 40.2841Z",
    fill: "#B3B6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7256 42.3137C20.2825 41.6659 19.3698 41.125 19.1726 40.7434C17.6733 37.8421 24.5365 11.5174 28.1708 7.16169C31.8052 2.80602 74.3425 17.4179 75.6229 19.8764C76.9033 22.335 69.3994 52.3492 66.4653 54.053C65.026 54.8888 53.9787 52.3999 42.9194 49.3045",
    stroke: "#2A2F54",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9205 26.4946C35.9596 23.9334 38.3488 22.6335 40.088 22.595C44.7531 22.4916 45.0409 34.2959 47.899 35.5996C50.6885 36.8719 55.4292 32.5304 58.7406 33.7703C60.3191 34.3614 61.9695 36.337 63.6917 39.6972M24.5237 34.9008C26.0724 33.1669 27.5268 31.6162 28.8867 30.2487L24.5237 34.9008Z",
    stroke: "#2A2F54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7297 29.3495C59.5116 29.827 61.343 28.7696 61.8205 26.9877C62.2979 25.2059 61.2405 23.3744 59.4587 22.897C57.6769 22.4196 55.8454 23.477 55.3679 25.2588C54.8905 27.0406 55.9479 28.8721 57.7297 29.3495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6379 26.5685C58.4198 27.0459 60.2512 25.9885 60.7287 24.2067C61.2061 22.4249 60.1487 20.5934 58.3669 20.1159C56.5851 19.6385 54.7536 20.6959 54.2762 22.4777C53.7987 24.2595 54.8561 26.091 56.6379 26.5685Z",
    stroke: "#2A2F54",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6795 86.3477C47.2461 86.9892 49.0361 86.2392 49.6776 84.6726C50.1052 83.6282 49.862 81.5257 48.9479 78.3651C46.0798 79.9771 44.432 81.3053 44.0043 82.3497C43.3629 83.9163 44.1129 85.7063 45.6795 86.3477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1834 88.0679C48.75 88.7094 50.54 87.9594 51.1815 86.3928C51.6091 85.3484 51.3659 83.2459 50.4519 80.0853C47.5837 81.6973 45.9359 83.0255 45.5082 84.0699C44.8668 85.6365 45.6168 87.4265 47.1834 88.0679Z",
    fill: "#FFB38E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6795 86.3477C47.2461 86.9892 49.0361 86.2392 49.6776 84.6726C50.1052 83.6282 49.862 81.5257 48.9479 78.3651C46.0798 79.9771 44.432 81.3053 44.0043 82.3497C43.3629 83.9163 44.1129 85.7063 45.6795 86.3477Z",
    stroke: "#2A2F54",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79696 86.4806C6.34913 87.1218 7.31654 87.194 7.95773 86.6418C8.59893 86.0896 8.6711 85.1222 8.11893 84.481C7.56676 83.8398 6.59935 83.7677 5.95815 84.3198C5.31696 84.872 5.24479 85.8394 5.79696 86.4806Z",
    fill: "#2A2F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3402 58.2319C18.6943 57.5652 20.692 56.1729 22.3335 54.055C23.9749 51.9371 25.0038 49.4243 25.4201 46.5165L49.2127 68.9523L35.7362 79.216C30.8366 74.8708 27.2962 71.5184 25.115 69.1586C22.9338 66.7988 20.0088 63.1566 16.3402 58.2319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3136 64.2076C27.8941 62.0531 33.1508 65.2 36.6614 65.9892C40.1721 66.7784 43.6368 67.5666 45.0213 69.4121C45.9442 70.6424 46.0081 72.0903 45.2127 73.7559C42.9935 76.2609 41.2368 77.7911 39.9424 78.3463C38.0008 79.1792 34.9203 76.5521 32.1391 73.5235C29.3579 70.4948 24.733 66.3621 26.3136 64.2076Z",
    fill: "#D7DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8397 71.8527L38.8061 76.8791M18.5111 57.3591C19.9488 56.5904 21.2232 55.4892 22.3344 54.0555C22.9896 53.2102 23.5471 52.3019 24.0071 51.3308",
    stroke: "#2A2F54",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.302 58.3312C17.5606 59.2123 21.0856 64.6906 25.9163 69.4861C30.9665 74.4995 37.3175 78.8442 38.057 80.0626C39.5039 82.4464 35.8562 85.4653 32.1254 84.4006C29.1597 83.5543 25.8979 76.0963 20.1673 80.2922C14.4366 84.488 11.6245 89.1016 7.54046 90.1904C3.45642 91.2792 0.126498 85.703 3.03386 82.9517C5.94122 80.2004 13.5598 79.1801 15.5666 76.3061C17.5734 73.432 18.2929 71.5035 15.2493 68.9918C12.2056 66.4801 11.0883 64.9357 11.1106 62.1218C11.1328 59.3079 13.7278 56.529 16.302 58.3312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8492 60.615C19.1165 61.4748 22.738 66.7173 27.6361 71.3483C32.7567 76.1897 39.1495 80.4325 39.9109 81.5975C41.4006 83.8767 37.8608 86.632 34.141 85.5403C31.1842 84.6725 27.776 77.572 22.2018 81.3858C16.6275 85.1996 13.9533 89.4765 9.93525 90.4041C5.91723 91.3316 2.48658 86.0014 5.29968 83.4804C8.11279 80.9593 15.6324 80.1808 17.5508 77.5225C19.4693 74.8643 20.1356 73.0656 17.0617 70.6278C13.9877 68.19 12.8445 66.7092 12.7992 64.0601C12.7539 61.411 15.2571 58.8564 17.8492 60.615Z",
    fill: "#92A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73909 88.5878C5.36951 86.4107 22.0398 76.6692 27.1184 74.0612C30.5042 72.3226 34.2355 74.4489 38.3122 80.4401C36.8756 82.5573 34.8616 83.4652 32.27 83.164C28.3827 82.7121 28.4096 78.1078 24.4669 78.8306C22.4756 79.1957 15.68 86.5377 10.0859 90.269C9.67682 90.5419 3.73902 92.0415 4.73909 88.5878Z",
    fill: "#677CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.302 58.3312C17.5606 59.2123 21.0856 64.6906 25.9163 69.4861C30.9665 74.4995 37.3175 78.8442 38.057 80.0626C39.5039 82.4464 35.8562 85.4653 32.1254 84.4006C29.1597 83.5543 25.8979 76.0963 20.1673 80.2922C14.4366 84.488 11.6245 89.1016 7.54046 90.1904C3.45642 91.2792 0.126498 85.703 3.03386 82.9517C5.94122 80.2004 13.5598 79.1801 15.5666 76.3061C17.5734 73.432 18.2929 71.5035 15.2493 68.9918C12.2056 66.4801 11.0883 64.9357 11.1105 62.1218C11.1328 59.3079 13.7278 56.529 16.302 58.3312Z",
    stroke: "#2A2F54",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7327 46.0932C31.5411 43.7506 27.9196 42.3975 25.6566 44.2316C23.3935 46.0657 23.6364 49.5796 25.3655 51.0458C27.0946 52.512 29.7272 52.6755 32.933 54.8C36.1389 56.9244 34.6856 60.3509 36.9028 62.5351C39.1201 64.7193 42.6383 64.7319 44.5986 66.8002C46.5588 68.8686 45.7164 72.6379 48.0334 73.5906C50.3503 74.5433 52.8033 73.453 51.7771 68.1844C50.751 62.9157 46.6707 60.4458 41.6966 56.3097C36.7226 52.1736 35.9244 48.4357 33.7327 46.0932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6765 48.2484C31.5614 46.0447 28.4523 44.4071 26.3227 46.0816C24.1932 47.7562 24.4692 51.0229 26.133 52.4068C27.7968 53.7907 30.3035 53.9762 33.3806 55.9904C36.4578 58.0046 35.119 61.1684 37.2564 63.2254C39.3938 65.2824 42.7411 65.3391 44.6325 67.2852C46.5239 69.2313 45.7707 72.7214 47.9872 73.6359C50.2037 74.5503 51.112 73.3778 50.0683 68.4712C49.0246 63.5647 46.2997 62.5875 41.5146 58.6824C36.7295 54.7773 35.7916 50.4522 33.6765 48.2484Z",
    fill: "#FFB38E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8909 45.3899C31.6993 43.0473 28.0778 41.6942 25.8148 43.5283C23.5517 45.3624 23.7946 48.8763 25.5237 50.3425C27.2528 51.8087 29.8854 51.9722 33.0913 54.0967C36.2971 56.2212 34.8438 59.6476 37.061 61.8318C39.2783 64.016 42.7965 64.0286 44.7568 66.0969C46.717 68.1653 45.8746 71.9346 48.1916 72.8873C50.5086 73.84 52.9615 72.7498 51.9354 67.4811C50.9092 62.2124 46.8289 59.7425 41.8549 55.6064C36.8808 51.4704 36.0826 47.7324 33.8909 45.3899Z",
    stroke: "#2A2F54",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.174 68.7772L36.3699 72.8291",
    stroke: "#A4ABE2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9852 67.3951L34.7629 69.3336",
    stroke: "#A4ABE2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4197 62.2536C82.9697 61.5539 84.8756 61.5539 87.1373 62.2536C90.4619 61.1238 92.269 60.7481 92.5585 61.1264C92.9928 61.6939 90.5596 64.6552 89.3193 66.6342C88.079 68.6133 91.0135 79.015 83.0137 84.5427C75.0139 90.0704 60.7055 83.562 58.5633 82.8295C56.421 82.097 67.2305 81.1349 68.5317 80.2924C69.1611 79.8849 65.6242 76.6822 63.7513 72.9403C61.7522 68.9463 61.406 64.403 62.0761 64.1211C63.374 63.5751 72.1024 69.1452 75.2708 68.7653C78.4392 68.3854 79.0946 63.3032 81.4197 62.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3337 62.6259C81.5424 61.8076 83.1384 61.5833 85.1218 61.953C87.7615 60.535 89.2268 59.9808 89.5176 60.2906C89.9538 60.7552 88.2943 63.7328 87.5085 65.6774C86.7226 67.6219 90.5086 76.7297 84.5155 82.6949C78.5223 88.66 65.709 84.4292 63.8214 84.0155C61.9339 83.6019 69.6927 81.424 70.6748 80.5052C71.1498 80.0607 68.9493 77.5978 66.9029 74.4176C64.7187 71.023 63.8485 66.9347 64.3736 66.5997C65.3907 65.9507 73.4115 69.9857 76.0163 69.2675C78.621 68.5494 78.5207 63.8534 80.3337 62.6259Z",
    fill: "#DEE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3591 61.1943C81.9092 60.4946 83.8151 60.4946 86.0768 61.1943C89.4014 60.0646 91.2084 59.6888 91.498 60.0672C91.9323 60.6347 89.499 63.5959 88.2587 65.575C87.0184 67.554 89.953 77.9557 81.9532 83.4834C73.9534 89.0111 59.6449 82.5028 57.5027 81.7702C55.3605 81.0377 66.1699 80.0756 67.4712 79.2331C68.1006 78.8256 64.5637 75.623 62.6908 71.8811C60.6917 67.8871 60.3455 63.3437 61.0156 63.0618C62.3134 62.5158 71.0418 68.0859 74.2103 67.7061C77.3787 67.3262 78.0341 62.2439 80.3591 61.1943Z",
    stroke: "#2A2F54",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewImage);
export default __webpack_public_path__ + "static/media/previewImage.0f15366636cfe536d17485997707e5ea.svg";
export { ForwardRef as ReactComponent };